import { Flame, Activity, Trophy, ArrowUpRight } from "lucide-react";

const ITEMS = [
  {
    id: "dimagrimento",
    icon: Flame,
    overline: "Servizio · 01",
    title: "Dimagrimento",
    desc: "Perdita di grasso reale e sostenibile, senza diete punitive. Costruiamo abitudini misurabili che proteggono il muscolo e l'energia quotidiana.",
    bullets: [
      "Deficit calibrato sul TDEE",
      "Educazione alimentare progressiva",
      "Strategie anti-stallo e ricariche",
    ],
  },
  {
    id: "ricomposizione",
    icon: Activity,
    overline: "Servizio · 02",
    title: "Ricomposizione Corporea",
    desc: "Aumentare la massa magra e ridurre il grasso corporeo nello stesso percorso. Macro chirurgici e periodizzazione coerente con l'allenamento.",
    bullets: [
      "Surplus / deficit alternati",
      "Macronutrienti calibrati individualmente",
      "Cicli di ricarica strategici",
    ],
    highlighted: true,
  },
  {
    id: "sport",
    icon: Trophy,
    overline: "Servizio · 03",
    title: "Sport & Performance",
    desc: "Nutrizione di precisione per powerlifting, bodybuilding, maratona, ciclismo, calcio e nuoto. Timing, idratazione, integrazione e recupero.",
    bullets: [
      "Carb periodization",
      "Pre / intra / post workout",
      "Integrazione evidence-based",
    ],
  },
];

export const Expertise = () => {
  return (
    <section
      id="servizi"
      data-testid="expertise-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-12 md:mb-16">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · Aree di intervento
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Tre obiettivi.
              <br />
              <span className="text-[#1F6E45]">Un solo metodo.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#4A5A52] text-base md:text-lg leading-relaxed">
              Ogni percorso è costruito su misura partendo da dati oggettivi e
              dagli obiettivi reali del cliente. Niente protocolli copiati,
              niente promesse miracolose: solo fisiologia applicata e una
              programmazione sostenibile.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {ITEMS.map((it) => (
            <Card key={it.id} {...it} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Card = ({ id, icon: Icon, overline, title, desc, bullets, highlighted }) => (
  <article
    data-testid={`expertise-card-${id}`}
    className={`group relative rounded-2xl p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 ${
      highlighted
        ? "bg-[#1F6E45] text-white border border-[#1F6E45] green-glow"
        : "bg-white border border-[#E1E7E3] hover:border-[#1F6E45]/50 soft-shadow"
    }`}
  >
    <div
      className={`w-12 h-12 rounded-xl grid place-items-center mb-6 ${
        highlighted ? "bg-white/15 text-white" : "bg-[#E8F2EC] text-[#1F6E45]"
      }`}
    >
      <Icon size={22} strokeWidth={1.8} />
    </div>

    <div
      className={`text-[10px] uppercase tracking-[0.22em] font-bold mb-3 ${
        highlighted ? "text-[#C7E8D5]" : "text-[#1F6E45]"
      }`}
    >
      {overline}
    </div>
    <h3
      className={`font-heading text-2xl md:text-[26px] font-bold tracking-tight mb-3 ${
        highlighted ? "text-white" : "text-[#0E1A14]"
      }`}
    >
      {title}
    </h3>
    <p
      className={`text-[15px] leading-relaxed mb-6 ${
        highlighted ? "text-white/85" : "text-[#4A5A52]"
      }`}
    >
      {desc}
    </p>
    <ul
      className={`space-y-2.5 pt-5 border-t ${
        highlighted ? "border-white/15" : "border-[#E1E7E3]"
      }`}
    >
      {bullets.map((b) => (
        <li key={b} className={`flex items-start gap-3 text-sm ${highlighted ? "text-white/90" : "text-[#0E1A14]"}`}>
          <span
            className={`w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0 ${
              highlighted ? "bg-white" : "bg-[#1F6E45]"
            }`}
          />
          {b}
        </li>
      ))}
    </ul>

    <ArrowUpRight
      size={20}
      className={`absolute top-7 right-7 transition-all ${
        highlighted ? "text-white/60 group-hover:text-white" : "text-[#C9D2CC] group-hover:text-[#1F6E45]"
      } group-hover:translate-x-1 group-hover:-translate-y-1`}
    />
  </article>
);
